import { render, staticRenderFns } from "./FutureDeliveryRequestDetail.vue?vue&type=template&id=3e4ba49e"
import script from "./FutureDeliveryRequestDetail.vue?vue&type=script&lang=js"
export * from "./FutureDeliveryRequestDetail.vue?vue&type=script&lang=js"
import style0 from "./FutureDeliveryRequestDetail.vue?vue&type=style&index=0&id=3e4ba49e&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports